import script from "./NftConstructorCommunity.vue?vue&type=script&setup=true&lang=js"
export * from "./NftConstructorCommunity.vue?vue&type=script&setup=true&lang=js"

import "./NftConstructorCommunity.vue?vue&type=style&index=0&id=077b9c5d&lang=scss"

const __exports__ = script;

export default __exports__